import { createReducer, on } from "@ngrx/store";
import { AuthState, initialAuthState } from "../auth.state";

import { AuthActions } from "../actions";

export const reducer = createReducer(
    initialAuthState,
    on(AuthActions.logOut, AuthActions.changePasswordSuccess, (): AuthState => initialAuthState),
    on(
        AuthActions.clearError,
        (state): AuthState => ({
            ...state,
            error: null,
        })
    ),
    on(
        AuthActions.clearErrorPendingTrue,
        AuthActions.watchLogin,
        AuthActions.processLogin,
        AuthActions.register,
        AuthActions.changePassword,
        AuthActions.verifyPassword,
        AuthActions.resetPassword,
        AuthActions.resetPasswordSuccess,
        (state): AuthState => ({
            ...state,
            error: null,
            pending: true,
        })
    ),
    on(
        AuthActions.logInSuccess,
        (state, { authUser }): AuthState => ({
            ...state,
            loggedIn: true,
            user: authUser,
            error: null,
            pending: false,
        })
    ),
    on(
        AuthActions.logInFailure,
        AuthActions.resetPasswordFailure,
        (state, { message }): AuthState => ({
            ...state,
            error: message !== "no user" ? message : null,
            pending: true,
        })
    ),
    on(
        AuthActions.registerFailure,
        AuthActions.validateInviteCodeFailure,
        (state, { message }): AuthState => ({
            ...state,
            error: message,
            pending: false,
            isInviteCodeValid: false,
        })
    ),
    on(
        AuthActions.stopPendingLogin,
        AuthActions.verifyPasswordSuccess,
        (state): AuthState => ({
            ...state,
            error: null,
            pending: false,
        })
    ),
    on(
        AuthActions.verifyPasswordFailure,
        (state, { message, errorCode }): AuthState => ({
            ...state,
            error: message,
            errorCode,
            pending: false,
        })
    ),
    on(
        AuthActions.validateInviteCodeSuccess,
        (state, { isInviteCodeValid, message }): AuthState => ({
            ...state,
            isInviteCodeValid,
            error: message,
            pending: isInviteCodeValid,
        })
    )
);
